import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  defaultColumnMappings,
  columnTypes,
  excludedColumns,
  requirementInformationMappings
} from '../requirements_constants';

import { getCurrentColumns } from './store/selectors/session';
import { getSort } from './store/selectors/query';
import { retrieveRecords } from './store/actions/search';
import { changeSort } from './store/actions/query';
import { hideOverlayFilters, showOverlayFilters } from './store/actions/ui';

import TableHeader from 'components/table_header/table_header';
import RequirementsColumnSelector from './column_selector';

export class RequirementsTableHeader extends React.Component {
  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    hideOverlayFilters: PropTypes.func.isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    sort: PropTypes.string.isRequired,
    onSortChange: PropTypes.func.isRequired
  };

  handleSortChange = (sortOption) => {
    const { onSortChange, retrieveRecords } = this.props;

    onSortChange(sortOption);
    retrieveRecords();
  }

  render() {
    const {
      currentColumns,
      hideOverlayFilters,
      showColumnFilters,
      showOverlayFilters,
      sort
    } = this.props;

    return (
      <TableHeader
        currentColumns={currentColumns}
        defaultColumnMappings={defaultColumnMappings}
        excludedColumns={excludedColumns}
        hideOverlayFilters={hideOverlayFilters}
        informationMappings={requirementInformationMappings}
        showColumnFilters={showColumnFilters}
        showOverlayFilters={showOverlayFilters}
        sort={sort}
        sortableColumnTypes={columnTypes}
        onSortChange={this.handleSortChange}
      >
        <RequirementsColumnSelector
          informationMappings={requirementInformationMappings}
          onCancelColumns={hideOverlayFilters}
        />
      </TableHeader>
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: getCurrentColumns(state),
  showColumnFilters: state.ui.showColumnFilters,
  sort: getSort(state)
});

const mapDispatchToProps = {
  hideOverlayFilters,
  retrieveRecords,
  showOverlayFilters,
  onSortChange: changeSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsTableHeader);